module.exports = __webpack_public_path__ + "static/img/Very_Good.a72fb0ee.png";